import { useClientTerminology } from '@/views/list/NetworkTerms';
import { Text, Button, Title } from '@mantine/core';
import styles from './CustomListEmptyMessage.module.css';

interface CustomListEmptyMessageProps {
  openAddSpansFilter?: () => void;
}

export default function CustomListEmptyMessage({
  openAddSpansFilter,
}: CustomListEmptyMessageProps) {
  const intl = useClientTerminology();

  return (
    <div className={styles.emptyMessageContainer}>
      <Title className={styles.header} order={2}>
        {intl.formatMessage({
          id: 'customList.scopeHeader',
          defaultMessage: "What's the scope?",
        })}
      </Title>
      <Text className={styles.text}>
        {intl.formatMessage({
          id: 'customList.addSpansDescription',
          defaultMessage:
            'Add spans to this project to easily track, share & return to later.',
        })}
      </Text>

      <Button
        radius="md"
        onClick={openAddSpansFilter}
        data-testid="add-spans-button"
      >
        {intl.formatMessage({
          id: 'customList.addSpans',
        })}
      </Button>
    </div>
  );
}
